var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "prjeditor",
        clickToClose: false,
        resizable: true,
        scrollable: true,
        reset: true,
        height: "auto",
        width: _vm.modalWidth,
      },
    },
    [
      _vm._v("\n  " + _vm._s(_vm.$t("prjeditor.TITLE")) + "\n  "),
      _c(
        "div",
        { staticClass: "dialogcontainer" },
        [
          _c("vue-form-generator", {
            attrs: {
              schema: _vm.schema,
              model: _vm.editProjectData,
              options: _vm.formOptions,
            },
          }),
          _c("destinations", {
            model: {
              value: _vm.editProjectData.dest,
              callback: function ($$v) {
                _vm.$set(_vm.editProjectData, "dest", $$v)
              },
              expression: "editProjectData.dest",
            },
          }),
          _c("p"),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "buttonscontainer",
          staticStyle: { padding: "6px" },
          attrs: { align: "center" },
        },
        [
          _c(
            "button",
            { staticClass: "quicktextbutton", on: { click: _vm.onDiscard } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("editor.BUTTON_DISCARD")) + "\n    "
              ),
            ]
          ),
          _c(
            "button",
            { staticClass: "quicktextbutton", on: { click: _vm.onSave } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("editor.BUTTON_SAVE")) + "\n    "
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }